"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ECWWeatherConditionIcon = exports.ECWUrgency = exports.ECWUnit = exports.ECWSeverity = exports.ECWResponse = exports.ECWMessageType = exports.ECWForecastPeriodType = exports.ECWFeaturePropertiesType = exports.ECWDirection = exports.ECWCertainty = exports.ECWAreaType = exports.ECWAreaAbbreviation = exports.ECWAlertCategoryGroup = void 0;
var ECWAlertCategoryGroup;
exports.ECWAlertCategoryGroup = ECWAlertCategoryGroup;
(function (ECWAlertCategoryGroup) {
  ECWAlertCategoryGroup["severe"] = "severe";
  ECWAlertCategoryGroup["flooding"] = "flooding";
  ECWAlertCategoryGroup["winter"] = "winter";
  ECWAlertCategoryGroup["tropical"] = "tropical";
  ECWAlertCategoryGroup["air"] = "air";
  ECWAlertCategoryGroup["heat"] = "heat";
  ECWAlertCategoryGroup["fog"] = "fog";
  ECWAlertCategoryGroup["wind"] = "wind";
  ECWAlertCategoryGroup["fire"] = "fire";
  ECWAlertCategoryGroup["marine"] = "marine";
  ECWAlertCategoryGroup["other"] = "other";
  ECWAlertCategoryGroup["administrative"] = "administrative";
})(ECWAlertCategoryGroup || (exports.ECWAlertCategoryGroup = ECWAlertCategoryGroup = {}));
var ECWAreaAbbreviation;
exports.ECWAreaAbbreviation = ECWAreaAbbreviation;
(function (ECWAreaAbbreviation) {
  ECWAreaAbbreviation["AK"] = "AK";
  ECWAreaAbbreviation["AL"] = "AL";
  ECWAreaAbbreviation["AM"] = "AM";
  ECWAreaAbbreviation["AN"] = "AN";
  ECWAreaAbbreviation["AR"] = "AR";
  ECWAreaAbbreviation["AS"] = "AS";
  ECWAreaAbbreviation["AZ"] = "AZ";
  ECWAreaAbbreviation["CA"] = "CA";
  ECWAreaAbbreviation["CO"] = "CO";
  ECWAreaAbbreviation["CT"] = "CT";
  ECWAreaAbbreviation["DC"] = "DC";
  ECWAreaAbbreviation["DE"] = "DE";
  ECWAreaAbbreviation["FL"] = "FL";
  ECWAreaAbbreviation["GA"] = "GA";
  ECWAreaAbbreviation["GM"] = "GM";
  ECWAreaAbbreviation["GU"] = "GU";
  ECWAreaAbbreviation["HI"] = "HI";
  ECWAreaAbbreviation["IA"] = "IA";
  ECWAreaAbbreviation["ID"] = "ID";
  ECWAreaAbbreviation["IL"] = "IL";
  ECWAreaAbbreviation["IN"] = "IN";
  ECWAreaAbbreviation["KY"] = "KY";
  ECWAreaAbbreviation["KS"] = "KS";
  ECWAreaAbbreviation["LA"] = "LA";
  ECWAreaAbbreviation["LC"] = "LC";
  ECWAreaAbbreviation["LE"] = "LE";
  ECWAreaAbbreviation["LH"] = "LH";
  ECWAreaAbbreviation["LM"] = "LM";
  ECWAreaAbbreviation["LO"] = "LO";
  ECWAreaAbbreviation["LS"] = "LS";
  ECWAreaAbbreviation["MA"] = "MA";
  ECWAreaAbbreviation["MD"] = "MD";
  ECWAreaAbbreviation["ME"] = "ME";
  ECWAreaAbbreviation["MI"] = "MI";
  ECWAreaAbbreviation["MN"] = "MN";
  ECWAreaAbbreviation["MO"] = "MO";
  ECWAreaAbbreviation["MS"] = "MS";
  ECWAreaAbbreviation["MT"] = "MT";
  ECWAreaAbbreviation["NA"] = "NA";
  ECWAreaAbbreviation["NC"] = "NC";
  ECWAreaAbbreviation["ND"] = "ND";
  ECWAreaAbbreviation["NE"] = "NE";
  ECWAreaAbbreviation["NH"] = "NH";
  ECWAreaAbbreviation["NJ"] = "NJ";
  ECWAreaAbbreviation["NM"] = "NM";
  ECWAreaAbbreviation["NV"] = "NV";
  ECWAreaAbbreviation["NY"] = "NY";
  ECWAreaAbbreviation["OH"] = "OH";
  ECWAreaAbbreviation["OK"] = "OK";
  ECWAreaAbbreviation["OR"] = "OR";
  ECWAreaAbbreviation["PA"] = "PA";
  ECWAreaAbbreviation["PH"] = "PH";
  ECWAreaAbbreviation["PK"] = "PK";
  ECWAreaAbbreviation["PM"] = "PM";
  ECWAreaAbbreviation["PR"] = "PR";
  ECWAreaAbbreviation["PS"] = "PS";
  ECWAreaAbbreviation["PZ"] = "PZ";
  ECWAreaAbbreviation["RI"] = "RI";
  ECWAreaAbbreviation["SD"] = "SD";
  ECWAreaAbbreviation["SC"] = "SC";
  ECWAreaAbbreviation["TN"] = "TN";
  ECWAreaAbbreviation["TX"] = "TX";
  ECWAreaAbbreviation["UT"] = "UT";
  ECWAreaAbbreviation["VA"] = "VA";
  ECWAreaAbbreviation["VI"] = "VI";
  ECWAreaAbbreviation["VT"] = "VT";
  ECWAreaAbbreviation["WA"] = "WA";
  ECWAreaAbbreviation["WI"] = "WI";
  ECWAreaAbbreviation["WV"] = "WV";
  ECWAreaAbbreviation["WY"] = "WY";
})(ECWAreaAbbreviation || (exports.ECWAreaAbbreviation = ECWAreaAbbreviation = {}));
var ECWAreaType;
exports.ECWAreaType = ECWAreaType;
(function (ECWAreaType) {
  ECWAreaType["Land"] = "Land";
  ECWAreaType["County"] = "County";
  ECWAreaType["Fire"] = "Fire";
  ECWAreaType["Public"] = "Public";
  ECWAreaType["Marine"] = "Marine";
  ECWAreaType["Coastal"] = "Coastal";
  ECWAreaType["OffShore"] = "Offshore";
})(ECWAreaType || (exports.ECWAreaType = ECWAreaType = {}));
var ECWCertainty;
exports.ECWCertainty = ECWCertainty;
(function (ECWCertainty) {
  ECWCertainty["observed"] = "observed";
  ECWCertainty["likely"] = "likely";
  ECWCertainty["possible"] = "possible";
  ECWCertainty["unlikely"] = "unlikely";
  ECWCertainty["unknown"] = "unknown";
})(ECWCertainty || (exports.ECWCertainty = ECWCertainty = {}));
var ECWDirection;
exports.ECWDirection = ECWDirection;
(function (ECWDirection) {
  ECWDirection["N"] = "N";
  ECWDirection["NE"] = "NE";
  ECWDirection["E"] = "E";
  ECWDirection["SE"] = "SE";
  ECWDirection["S"] = "S";
  ECWDirection["SW"] = "SW";
  ECWDirection["W"] = "W";
  ECWDirection["NW"] = "NW";
  ECWDirection["Unknown"] = "Unknown";
})(ECWDirection || (exports.ECWDirection = ECWDirection = {}));
var ECWFeaturePropertiesType;
exports.ECWFeaturePropertiesType = ECWFeaturePropertiesType;
(function (ECWFeaturePropertiesType) {
  ECWFeaturePropertiesType["alert"] = "alert";
  ECWFeaturePropertiesType["zoneAlert"] = "zoneAlert";
  ECWFeaturePropertiesType["land"] = "land";
  ECWFeaturePropertiesType["coastal"] = "coastal";
  ECWFeaturePropertiesType["county"] = "county";
  ECWFeaturePropertiesType["fire"] = "fire";
  ECWFeaturePropertiesType["marine"] = "marine";
  ECWFeaturePropertiesType["offShore"] = "offShore";
  ECWFeaturePropertiesType["forecast"] = "forecast";
  ECWFeaturePropertiesType["unknown"] = "unknown";
})(ECWFeaturePropertiesType || (exports.ECWFeaturePropertiesType = ECWFeaturePropertiesType = {}));
var ECWForecastPeriodType;
exports.ECWForecastPeriodType = ECWForecastPeriodType;
(function (ECWForecastPeriodType) {
  ECWForecastPeriodType["Current"] = "Current";
  ECWForecastPeriodType["Hourly"] = "Hourly";
  ECWForecastPeriodType["Daily"] = "Daily";
})(ECWForecastPeriodType || (exports.ECWForecastPeriodType = ECWForecastPeriodType = {}));
var ECWMessageType;
exports.ECWMessageType = ECWMessageType;
(function (ECWMessageType) {
  ECWMessageType["alert"] = "alert";
  ECWMessageType["update"] = "update";
  ECWMessageType["cancel"] = "cancel";
  ECWMessageType["acknowledge"] = "acknowledge";
  ECWMessageType["error"] = "error";
  ECWMessageType["unknown"] = "unknown";
})(ECWMessageType || (exports.ECWMessageType = ECWMessageType = {}));
var ECWResponse;
exports.ECWResponse = ECWResponse;
(function (ECWResponse) {
  ECWResponse["shelter"] = "shelter";
  ECWResponse["evacuate"] = "evacuate";
  ECWResponse["prepare"] = "prepare";
  ECWResponse["execute"] = "execute";
  ECWResponse["avoid"] = "avoid";
  ECWResponse["monitor"] = "monitor";
  ECWResponse["assess"] = "assess";
  ECWResponse["allClear"] = "allClear";
  ECWResponse["none"] = "none";
  ECWResponse["unknown"] = "unknown";
})(ECWResponse || (exports.ECWResponse = ECWResponse = {}));
var ECWSeverity;
exports.ECWSeverity = ECWSeverity;
(function (ECWSeverity) {
  ECWSeverity["extreme"] = "extreme";
  ECWSeverity["severe"] = "severe";
  ECWSeverity["moderate"] = "moderate";
  ECWSeverity["minor"] = "minor";
  ECWSeverity["unknown"] = "unknown";
})(ECWSeverity || (exports.ECWSeverity = ECWSeverity = {}));
var ECWUnit;
exports.ECWUnit = ECWUnit;
(function (ECWUnit) {
  ECWUnit["C"] = "C";
  ECWUnit["F"] = "F";
  ECWUnit["Percent"] = "Percent";
  ECWUnit["Mph"] = "Mph";
  ECWUnit["Kph"] = "Kph";
  ECWUnit["Unknown"] = "Unknown";
})(ECWUnit || (exports.ECWUnit = ECWUnit = {}));
var ECWUrgency;
exports.ECWUrgency = ECWUrgency;
(function (ECWUrgency) {
  ECWUrgency["immediate"] = "immediate";
  ECWUrgency["expected"] = "expected";
  ECWUrgency["future"] = "future";
  ECWUrgency["past"] = "past";
  ECWUrgency["unknown"] = "unknown";
})(ECWUrgency || (exports.ECWUrgency = ECWUrgency = {}));
var ECWWeatherConditionIcon;
exports.ECWWeatherConditionIcon = ECWWeatherConditionIcon;
(function (ECWWeatherConditionIcon) {
  ECWWeatherConditionIcon["Blizzard"] = "Blizzard";
  ECWWeatherConditionIcon["Dust"] = "Dust";
  ECWWeatherConditionIcon["Fair"] = "Fair";
  ECWWeatherConditionIcon["FewClouds"] = "FewClouds";
  ECWWeatherConditionIcon["Fog"] = "Fog";
  ECWWeatherConditionIcon["FreezingRain"] = "FreezingRain";
  ECWWeatherConditionIcon["FreezingRainRain"] = "FreezingRain";
  ECWWeatherConditionIcon["FreezingRainSnow"] = "FreezingRainSnow";
  ECWWeatherConditionIcon["FunnelCloud"] = "FunnelCloud";
  ECWWeatherConditionIcon["Haze"] = "Haze";
  ECWWeatherConditionIcon["Hot"] = "Hot";
  ECWWeatherConditionIcon["Hurricane"] = "Hurricane";
  ECWWeatherConditionIcon["IcePellet"] = "IcePellet";
  ECWWeatherConditionIcon["LightRain"] = "LightRain";
  ECWWeatherConditionIcon["MostlyCloudy"] = "MostlyCloudy";
  ECWWeatherConditionIcon["Overcast"] = "Overcast";
  ECWWeatherConditionIcon["PartlyCloudy"] = "PartlyCloudy";
  ECWWeatherConditionIcon["Rain"] = "Rain";
  ECWWeatherConditionIcon["RainIcePellet"] = "RainIcePellet";
  ECWWeatherConditionIcon["RainShower"] = "RainShower";
  ECWWeatherConditionIcon["RainSnow"] = "RainSnow";
  ECWWeatherConditionIcon["ShowersInVicinity"] = "ShowersInVicinity";
  ECWWeatherConditionIcon["Smoke"] = "Smoke";
  ECWWeatherConditionIcon["Snow"] = "Snow";
  ECWWeatherConditionIcon["Thunderstorm"] = "Thunderstorm";
  ECWWeatherConditionIcon["ThunderstormsInVicinity"] = "ThunderstormsInVicinity";
  ECWWeatherConditionIcon["Tornado"] = "Tornado";
  ECWWeatherConditionIcon["TropicalStorm"] = "TropicalStorm";
  ECWWeatherConditionIcon["Unknown"] = "Unknown";
  ECWWeatherConditionIcon["Windy"] = "Windy";
})(ECWWeatherConditionIcon || (exports.ECWWeatherConditionIcon = ECWWeatherConditionIcon = {}));